import { html, LitElement, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import style from './ui-tag.css?inline';

const CName = 'ui-tag';

@customElement(CName)
export class UITag extends LitElement {
  static readonly styles = unsafeCSS(style);
  @property({ type: Boolean }) noAction = false;
  @property({ type: Boolean }) circle = false;
  @property({ type: String }) colorVariant: 'default' | 'outlined' | 'vivid' = 'default';
  @property({ type: String }) size: 'sm' | 'md' = 'sm';

  render() {
    const classes = classMap({
      tag: true,
      'tag--no-action': this.noAction,
      'tag--circle': this.circle,
      [`tag--${this.colorVariant}`]: this.colorVariant,
      [`tag--${this.size}`]: this.size,
    });
    return html`
      ${
        this.noAction
          ? html`<div class=${classes}><slot></slot></div>`
          : html`<button class=${classes}><slot></slot></button>`
      }
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UITag;
  }
}
